var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAddNewNoBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_small-plus_24px",
    "data-name": "icon/small-plus_24px",
    transform: "translate(-0.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundry",
    width: 24,
    height: 24,
    transform: "translate(0.35)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    y2: 8,
    transform: "translate(4.35 0)",
    fill: "none",
    stroke: "#3bb0ff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x2: 8,
    transform: "translate(0.35 4)",
    fill: "none",
    stroke: "#3bb0ff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddNewNoBackground);
export default __webpack_public_path__ + "static/media/icon-add_new_no_background.2823900a0a103e5dd1b6924c125abdcf.svg";
export { ForwardRef as ReactComponent };